import '../../css/sections/HeroSection.css';
import Typewriter from 'typewriter-effect';
import Navigation from './Navigation';

function HeroSection({ darkLogo }) {
    return (
        <div className='hero-container' style={{ backgroundColor: 'var(--bg1)', position: 'relative', overflow: 'hidden' }}
            id='home'>
            <img
                src="/images/background1.svg"
                alt=""
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    repeat: 'no-repeat',
                    zIndex: 0,
                    pointerEvents: 'none',
                    opacity: 1
                }}
            />
            <Navigation darkLogo={darkLogo} />
            <div className='hero-text'>
                {/*
                  * The visible name is typed out by Typewriter, so the DOM only ever holds a
                  * partially typed string plus a cursor glyph. The visually hidden span carries
                  * the real, complete name for crawlers and screen readers; the animation is
                  * decoration and is hidden from the accessibility tree.
                  */}
                <h1 className='special-font2' style={{ fontWeight: '500' }}>
                    <span className='visually-hidden'>Samuel Banczík</span>
                    <span aria-hidden='true'>
                        <Typewriter
                            options={{
                                strings: ['SAMUEL'],
                                cursorStyle: "_",
                                autoStart: true,
                                loop: false,
                                deleteSpeed: Infinity,
                            }}
                        />
                    </span>
                </h1>
                <h1 className='special-font2' style={{ fontWeight: '500' }} aria-hidden='true'>
                    <Typewriter
                        options={{
                            strings: ['BANCZÍK'],
                            cursorStyle: "_",
                            autoStart: true,
                            loop: false,
                            deleteSpeed: Infinity,
                        }}
                    />
                </h1>
                <p>Building <span className='special-font' style={{ fontStyle: "italic" }}>Code Today</span>, Building My Own <span className='special-font' style={{ fontStyle: "italic" }}>Startups Tomorrow</span></p>
            </div>
        </div>
    );
}

export default HeroSection;
